import { PromoComponentImportPage } from "@/features/promo/pages/PromoComponentImportPage";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/admin/promo/import")({
	validateSearch: z.object({
		promoTypeID: z.string().uuid(),
	}),
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["promo.create"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	const { promoTypeID } = Route.useSearch();
	return <PromoComponentImportPage promoTypeID={promoTypeID} />;
}
